module.exports = "/_next/static/public/images/onboarding-desktop-fa59aa59f668f940e58ab2cb189ca6d0.jpg";